var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M140 20c66.274 0 120 53.726 120 120s-53.726 120-120 120S20 206.274 20 140 73.726 20 140 20m-5.825 180c-8.284 0-15 6.716-15 15s6.716 15 15 15 15-6.716 15-15-6.716-15-15-15m5-140c-24.212 0-44.405 17.21-49.013 40.064-1.092 5.414 3.49 9.936 9.013 9.936h14c3.313 0 5.91-2.746 6.888-5.912C122.584 95.928 130.187 90 139.175 90c11.045 0 20 8.954 20 20s-8.955 20-20 20-20 8.954-20 20v20c0 5.523 4.477 10 10 10h10c5.523 0 10-4.477 10-10v-11c22.822-4.633 40-24.81 40-49 0-27.614-22.386-50-50-50"
})));
export default SvgHelp;